module.exports = window["SSCUIReact"];